// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"3066":"quick-registration","3524":"app"}[chunkId] || chunkId) + "." + {"2405":"f47e731f","3066":"3e5d582a","3524":"f47e731f","7279":"f47e731f"}[chunkId] + ".chunk.css";
};